import { Route, Routes } from "react-router-dom"
import Inicio from "../Screens/SInicio/Inici/Inicio"
import Costo from "../Screens/SCosto/Costo/Costo"
import Rubro from "../Screens/SRubro/Card/Rubros"

export default function AppRouter() {

  return (
    <>
      <Routes>
        <Route path={"/"} element={<Inicio />} />
        <Route path={"/rubro"} element={<Rubro />} />
        <Route path={"/costo"} element={<Costo />} />
      </Routes>
    </>
  )
}
